var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 827,
    viewBox: "0 0 600 827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#14B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.266%",
    stopColor: "#12ABC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0275B6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 .135h64.73v83.286H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M35.937.133C15.465.133 0 16.924 0 38.976 0 62.034 16.848 81.288 38.711 83.42V54.084c-10.239-1.007-17.276-8.948-17.276-19.472 0-10.189 6.504-17.578 15.461-17.578 8.212 0 13.756 5.376 13.756 13.322 0 7.054-4.262 11.645-11.94 12.876v10.852C54.49 53.646 64.73 43.569 64.73 28.45 64.73 12.108 52.577.133 35.937.133z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h600v827H0z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M100 181h200l-100 65.5L100 181zm0-.5L200 115l100 65.5H100z",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M300 543h200l-100 65.5L300 543zm0-.5L400 477l100 65.5H300z",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M400 724h200l-100 65.5L400 724zm0-.5L500 658l100 65.5H400z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 362h200l-100 65.5L0 362zm0-.5L100 296l100 65.5H0z",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M300 181h200l-100 65.5L300 181zm0-.5L400 115l100 65.5H300zM400 362h200l-100 65.5L400 362zm0-.5L500 296l100 65.5H400z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M500 543l100 65.5V477z",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M100 65.5v115L200 115V0z",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M300 427.5v115L400 477V362z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M100 427.5v115L200 477V362z",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M100 65.5v115L0 115V0zM300 427.5v115L200 477V362z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M300 65.5v115L400 115V0z",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M500 427.5v115L600 477V362z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M200 246.5v115L300 296V181z",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M400 608.5v115L500 658V543z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M300 789.5V827h100V724z",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M400 246.5v115L500 296V181z",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M300 65.5v115L200 115V0z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M500 427.5v115L400 477V362z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M200 246.5v115L100 296V181zM400 608.5v115L300 658V543z",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M500 789.5V827H400V724z",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M400 246.5v115L300 296V181z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M600 608.5v115L500 658V543z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M600 246.5v115L500 296V181z",
    opacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M431.655 369.556c0 1.238-1.138 2.149-2.573 2.112-1.346-.032-2.615-.626-2.615-.626l.295-.993s1.293.603 2.259.594c.913-.01 1.498-.431 1.498-1.087 0-.796-.764-1.02-1.66-1.294-1.083-.325-2.316-.708-2.316-2.242 0-1.225 1.042-2.034 2.539-2.076 1.077-.032 2.368.54 2.368.54l-.297.988s-1.175-.53-2.01-.503c-.896.03-1.472.409-1.472 1.05 0 .746.753.98 1.63 1.237 1.1.328 2.354.708 2.354 2.3zm7.644-5.486l-2.425 3.463-2.418-3.463h-1.05v7.47h1.08v-5.61l2.063 2.963h.642l2.076-2.967v5.613h1.081v-7.469h-1.049zM374.053 374.865c-3.3 0-6.383 1.454-8.301 4.134l-.424-3.462h-4.363v38.086h5.215v-13.065c1.592 1.564 4.572 2.68 7.126 2.68 7.133 0 11.924-6.033 11.924-14.745 0-8.154-4.474-13.628-11.177-13.628zm-1.595 23.46c-2.344 0-4.895-1.23-6.171-2.904v-8.161c0-4.573 2.66-7.483 6.7-7.483 4.258 0 6.919 3.355 6.919 8.716 0 6.254-2.768 9.831-7.448 9.831zm-137.37-32.62v36.972h5.424v-13.07h7.235c7.448 0 12.45-4.801 12.45-11.95 0-7.145-5.002-11.952-12.45-11.952h-12.66zm5.424 4.807h6.493c4.891 0 7.766 2.566 7.766 7.146s-2.875 7.148-7.766 7.148h-6.493v-14.294zm35.325 4.577c-2.977 0-5.743 1.447-7.233 3.91l-.426-3.462h-4.363v27.14h5.217v-14.629c0-5.253 2.34-8.04 6.805-8.04.75 0 1.811.218 2.875.44l.638-4.689c-1.064-.45-2.237-.67-3.513-.67zm10.218-3.462c1.913 0 3.298-1.454 3.298-3.463 0-2.009-1.385-3.46-3.298-3.46-1.916 0-3.404 1.451-3.404 3.46s1.488 3.463 3.404 3.463zm2.551 31.05v-27.14h-5.21v27.14h5.21zm19.9-27.812c-3.404 0-6.383 1.564-8.297 4.134l-.426-3.462h-4.367v27.14h5.219v-15.19c0-4.578 2.763-7.71 6.702-7.71 3.51 0 5.748 2.348 5.748 6.031v16.869h5.212v-17.539c0-6.139-3.936-10.273-9.791-10.273zm27.133 4.912c2.13 0 4.579 1.009 6.6 2.575l2.337-4.02c-2.337-2.128-5.848-3.467-9.147-3.467-7.556 0-13.088 5.92-13.088 14.183 0 8.605 5.108 14.19 12.767 14.19 3.62 0 7.345-1.338 9.468-3.462l-2.337-3.91c-1.916 1.67-4.044 2.458-6.388 2.458-4.999 0-8.195-3.577-8.195-9.276 0-5.581 3.196-9.271 7.983-9.271zm88.746 18.768c-1.81 0-2.447-.776-2.447-2.904v-31.614h-5.215v32.396c0 4.355 2.342 6.816 6.703 6.816 1.063 0 2.234-.225 2.977-.562l-.53-4.353c-.425.11-1.065.22-1.488.22zm-72.571-26.918c1.914 0 3.296-1.454 3.296-3.463 0-2.009-1.382-3.46-3.296-3.46s-3.404 1.451-3.404 3.46 1.49 3.463 3.404 3.463zm2.556 31.05v-27.14h-5.213v27.14h5.213zm50.438-16.305c-1.599-.45-3.727-.667-5.643-.667-6.81 0-10.855 3.458-10.855 9.152 0 5.031 3.834 8.382 9.368 8.382 3.296 0 5.96-1.34 7.766-3.69.745 2.35 2.659 3.69 5.215 3.69 1.064 0 2.232-.225 2.98-.562l-.531-4.242c-.426.11-.962.222-1.385.222-1.276 0-1.812-.67-1.812-2.007v-11.734c0-6.251-3.93-10.051-10.429-10.051-3.187 0-6.81.894-9.896 2.458l1.599 4.357c2.235-1.341 4.896-2.123 7.447-2.123 4.044 0 6.176 1.9 6.176 5.581v1.234zm0 5.472c0 4.36-2.45 6.928-6.49 6.928-2.98 0-4.789-1.677-4.789-4.358 0-3.015 2.342-4.806 6.274-4.806 1.916 0 3.406.225 5.005.564v1.672z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 348.587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M64.73 28.452C64.73 12.11 52.577.135 35.937.135 15.463.135 0 16.924 0 38.978c0 23.058 16.848 42.31 38.711 44.443V54.086c-10.239-1.01-17.276-8.95-17.276-19.475 0-10.186 6.504-17.577 15.461-17.577 8.212 0 13.756 5.375 13.756 13.323 0 7.052-4.262 11.643-11.94 12.875v10.854c15.779-.44 26.018-10.517 26.018-25.634",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 348.587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M0 83.421h64.73V.135H0z",
    mask: "url(#e)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.a12d15b6fb02895bd98b6f87bc885e17.svg";
export { ForwardRef as ReactComponent };